(() => {
  if (customElements.get('ol-product-help')) return;
  const color = value => String(value || '').toLowerCase().replaceAll('weiss', 'weiß').trim();
  class ProductHelp extends HTMLElement {
    connectedCallback() {
      this.onVariant = event => {
        if (String(event.detail?.product?.id) !== this.dataset.productId) return;
        this.update(event.detail.variant);
      };
      document.addEventListener('on:variant:change', this.onVariant);
      const documents = this.querySelector('[data-documents]');
      if (documents) {
        const section = this.closest('main') || document;
        const disclosure = [...section.querySelectorAll('details')].find(details => {
          const heading = details.querySelector('summary')?.textContent || '';
          return /Konformität|conformity|Datenblatt|data sheet|Unterlagen/i.test(heading) && details.querySelector('a[href*=".pdf"]');
        });
        if (disclosure) {
          documents.hidden = false;
          documents.onclick = () => {
            const summary = disclosure.querySelector('summary');
            if (!disclosure.open) summary.click();
            summary.scrollIntoView({ block: 'center' });
            summary.focus({ preventScroll: true });
          };
        }
      }
    }
    disconnectedCallback() {
      document.removeEventListener('on:variant:change', this.onVariant);
    }
    update(variant) {
      const included = this.querySelector('[data-included]');
      if (included) {
        const title = String(variant?.title || '').toLowerCase();
        included.textContent = title.includes('ohne reinigungsgeräte') ? included.dataset.without : title.includes('mit reinigungsgeräte') ? included.dataset.with : included.dataset.choose;
      }
      this.querySelectorAll('[data-complement]').forEach(card => {
        if (card.dataset.single === 'true') return;
        const variants = JSON.parse(card.querySelector('[data-complement-variants]').textContent);
        const match = variant && variants.find(candidate => candidate.available && color(candidate.color) === color(variant.option1 || variant.options?.[0]));
        const label = card.querySelector('[data-color]');
        card.href = match ? `${card.dataset.url}?variant=${match.id}` : card.dataset.url;
        label.textContent = match ? `${label.dataset.matched}: ${match.color}` : label.dataset.select;
        if (match?.image) {
          const image = card.querySelector('img');
          image.src = match.image;
          image.srcset = match.image;
          image.alt = card.querySelector('strong').textContent + ' – ' + match.color;
        }
      });
    }
  }
  customElements.define('ol-product-help', ProductHelp);
})();
